<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title v-ripple style="cursor: pointer" @click="fetchData(onlyTrashed)">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">Artigos {{onlyTrashed ? ' removidos' : ''}}</span>
                    </template>
                    <span>Clique para actualizar</span>
                </v-tooltip>
            </v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="mr-2 mb-2" fill-height
                  v-model="search"
                  append-icon="search"
                  label="procurar artigos..."
                  clearable
                  single-line
                  hide-details
            ></v-text-field>

            <v-btn v-if="!onlyTrashed && permissionToAdd" color="primary" icon @click="openModal"><v-icon>add</v-icon></v-btn>
            <article-form-modal
                :article_types="article_types"
                :active_states="active_states"
                :categories="categories"
                :subcategories="subcategories"
                @onFormArticleDone="fetchData()"
            >
            </article-form-modal>

        </v-toolbar>

        <v-data-table xs12 sm6 md4
            :headers="headers"
            :items="articles"
            :loading="loading"
            class="elevation-1"
            :no-data-text="noDataText()"
            :rows-per-page-items="Global.ROWS_PER_PAGE"
            :pagination.sync="pagination"
            hide-actions
            no-results-text="nenhum resultado"
            rows-per-page-text="por página"
            disable-initial-sort
        >
            <v-progress-linear v-slot:progress color="indigo" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.code }}/{{ props.item.series}}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-center">{{props.item.article_type ? props.item.article_type.name : '-----'}}</td>
                <td class="text-xs-right">{{ props.item.price | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                <td class="text-xs-right">{{ props.item.stock}}</td>
                <td class="text-xs-center"><v-chip outline :color="props.item.active_state ? 'green' : 'red'">{{ props.item.active_state ? 'ativo' : 'inativo' }}</v-chip></td>
                <td class="text-xs-right">{{ props.item.created_at | formatDate}}</td>
                <td class="text-xs-right" style="min-width: 120px; padding-right: 10px;">
                    <v-icon v-if="!onlyTrashed" small class="mr-2" @click="showItem(props.item)">visibility</v-icon>
                    <v-icon v-if="!onlyTrashed && permissionToUpdate" small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                    <v-icon v-if="!onlyTrashed && permissionToDelete" small class="mr-2" @click="deleteItem(props.item)">block</v-icon>
                    <v-icon v-if="onlyTrashed" small class="mr-2" @click="restoreTrashedItem(props.item)">replay</v-icon>
                    <!--<v-icon v-if="onlyTrashed" small class="mr-2" @click="deleteTrashedItem(props.item)">delete_forever</v-icon>-->
                </td>
            </template>
            <template v-slot:footer>
                <td :colspan="headers.length">
                    <custom-pagination
                        :totalData="totalData"
                        @onPaginationChange="paginationChangeCallBack($event)"
                        :disabled="loading"
                    ></custom-pagination>
                </td>
            </template>
            <template v-if="error_fetching" slot="no-data">
                <v-btn flat color="primary" @click="fetchData(onlyTrashed)"><v-icon>refresh</v-icon></v-btn>
                <span class="text-xs-center">nenhum dado encontrado</span>
            </template>
        </v-data-table>

        <v-dialog persistent max-width="290" v-model="openConfirmationDialog" @close="openConfirmationDialog = false">
            <v-card>

                <v-card-text class="text-xs-center">
                    <p v-if="confirmationModalOp === 1">Tens a certeza que queres eliminar <br> <b>{{selectedArticle.name}}</b>?</p>
                    <p v-if="confirmationModalOp === 2">Tens a certeza que queres <br> <span class="green--text text--darken-2">restaurar</span> <br><b>{{selectedArticle.name}}</b>?</p>
                    <p v-if="confirmationModalOp === 3">Tens a certeza que queres <br> <span class="red--text text--darken-2">eliminar permanentemente</span> <br><b>{{selectedArticle.name}}</b>?</p>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn color="red darken-1" flat @click="confirmationDialogYes">Sim</v-btn>
                        <v-btn color="grey darken-1" flat @click="close">Não</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-btn @click="fetchData(!onlyTrashed)" slot="activator" dark small :color="onlyTrashed ? 'red' : 'indigo'">
            {{onlyTrashed ? 'Sair de ' : ''}}Artigos removidos
        </v-btn>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ArticleFormModal from './FormModal';
    import {mapGetters} from 'vuex';
    import _ from 'lodash';
    import {eventBus} from "../../main";
    import {Permissions, Global} from "../../config";
    import CustomPagination from '../extra/CustomPagination.vue';

    export default {

        data: () => ({
            Global,
            pagination: {},
            totalData: 0,
            Permissions: Permissions,
            loading: false, //loading for list of articles in the datatable
            loading_modal: false, //loading for the action buttons in form modal
            error_fetching: false,  //error for fetching list of articles in the datatable
            search: '', //search for the datatable
            openConfirmationDialog: false, //loads confirmation modal with yes or no
            headers: [
                { text: 'Codigo Artigo', align: 'left', value: 'code'},
                { text: 'Nome', align: 'left', value: 'name', sortable: true },
                { text: 'Tipo Artigo', align: 'center', value: 'article_type_name' },
                { text: 'Preço', align: 'right', value: 'price' },
                { text: 'Stock', align: 'right', value: 'stock' },
                { text: 'Estado', align: 'center', value: 'active_state' },
                { text: 'Adicionado em', align: 'right', value: 'created_at' },
                { text: 'Ações', align: 'right', value: '', sortable: false }
            ],

            articles: [],
            article_types: [],
            active_states: [{id: 0, name: 'inativo'}, {id: 1, name: 'ativo'}],
            selectedIndex: -1, //the index of the selected client, useful for delete, add, update, restore, permanently delete
            onlyTrashed: false, //displays only trashed items or not
            confirmationModalOp: 0, //used for getting the confirmation actions (delete, restore, permanently delete)

            categories: [],
            subcategories: [],

        }),

        components: {
            ArticleFormModal,
            CustomPagination,
        },

        watch: {
            search() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.fetchData();
                }, 800);
            },
            pagination(){
                this.fetchData();
            }
        },

        computed: {
            ...mapGetters([
                'getNewArticle',
                'getNewCompany',
                'getToken'
            ]),
            permissionToAdd(){
                return this.hasPermission(Permissions.ARTICLE_ADD);
            },
            permissionToUpdate(){
                return this.hasPermission(Permissions.ARTICLE_UPDATE);
            },
            permissionToDelete(){
                return this.hasPermission(Permissions.ARTICLE_DELETE);
            },
            showArticleModal: {
                get(){
                    return this.$store.getters.getShowArticleModal;
                },
                set(value){
                    this.$store.dispatch('setShowArticleModal', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            selectedArticle: {
                get(){
                    return this.$store.getters.getSelectedArticle;
                },
                set(value){
                    this.$store.dispatch('setSelectedArticle', value);
                }
            },
            articleShow: {
                get(){
                    return this.$store.getters.getArticleShow;
                },
                set(value){
                    this.$store.dispatch('setArticleShow', value);
                }
            },
        },

        methods: {

            noDataText(){
                return this.loading ? 'a carregar artigos ...' : 
                        this.onlyTrashed ? 'Nenhum artigo removido.' : 'nenhum artigo.';
            },

            paginationChangeCallBack(payload){
                this.consoleLog('paginationChangeCallBack');
                this.pagination.rowsPerPage = payload.byPage;
                this.pagination.page = payload.currentPage;
                this.fetchData();
            },

            fetchData(onlyTrashed = false){
                if(this.loading) return;
                try{
                    this.onlyTrashed = onlyTrashed;
                    let url = onlyTrashed ? 'article/trashed' : 'article';

                    this.articles = [];
                    this.loading = true;
                    this.error_fetching = false;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.get(url, {
                        params: {                            
                            pag_size: this.pagination.rowsPerPage,
                            pag_current: this.pagination.page,
                            sort_field: this.getSortBy(this.pagination),
                            sort_order: this.getSortDes(this.pagination),
                            search: this.search,
                        }
                    })
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            this.error_fetching = true;
                            return;
                        }
                        // if(response.data.response === 'company_deactivated'){
                        //     this.showSnackBar('Sua empresa está de momento sem acesso a nhaFatura.', 'info');
                        //     return;
                        // }else if(response.data.response === 'maintenance_mode_on'){
                        //     this.showSnackBar('Estamos em manutenção por favor aguarde um pouco.', 'info');
                        //     return;
                        // }else if(response.data.response === 'notAuthorized'){
                        //     this.showSnackBar('Nao tens permissão.', 'info');
                        //     return;
                        // }

                        this.articles = response.data.response.articles;
                        this.article_types = response.data.response.articleTypes;
                        this.categories = response.data.response.articleCategory;
                        this.subcategories = response.data.response.articleSubcategory;

                        this.totalData = response.data.response.total_data;

                        // this.consoleLog(response);
                        // this.totalRows = this.articles.length;
                    }).catch(error => {
                        this.consoleLog(error);
                        this.error_fetching = true;
                        this.showSnackBar('Erro ao carregar artigos!!!', 'error');
                    }).finally(()=>{
                        this.loading = false;
                });
                }catch (e) {
                    this.consoleLog(e);
                    this.showSnackBar('Ocorreu um erro ao carregar lista de artigos!', 'error');
                    this.loading_modal = false;
                }
            },

            delete(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedArticle.name;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.delete('article/'+this.selectedArticle.id)
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        if(response.data.response === 'notAuthorized'){
                            this.showSnackBar('Não tens permissão.', 'info');
                            return;
                        }
                        this.articles.splice(this.selectedIndex, 1);
                        this.showSnackBar(name+' removido com sucesso', 'success');
                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao remover artigo', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedArticle = this.getNewArticle;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao remover empresa!', 'error');
                    this.loading_modal = false;
                }
            },

            restoreTrashed(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedArticle.name;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.put('article/trashed/restore/'+this.selectedArticle.id)
                    .then(response => {
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            this.loading_modal = false;
                            return;
                        }
                        this.articles.splice(this.selectedIndex, 1);

                        this.selectedIndex = -1;
                        this.showSnackBar(name+' restaurado com sucesso', 'success');
                    }).catch(error => {
                        // this.consoleLog(error);
                        this.selectedIndex = -1;
                        this.showSnackBar('Ocorreu um erro ao restaurar artigo', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedArticle = this.getNewArticle;
                    });
                }catch (e) {
                    this.loading_modal = false;
                    this.showSnackBar('Ocorreu um erro ao restaurar artigo', 'error');
                }
            },

            deleteTrashed(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedArticle.name;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.delete('article/trashed/delete/'+this.selectedArticle.id)
                    .then(response => {
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            this.loading_modal = false;
                            return;
                        }
                        this.articles.splice(this.selectedIndex, 1);
                        this.showSnackBar(name+' foi eliminado permanentemente com sucesso', 'success');
                    }).catch(error => {
                        this.showSnackBar('Ocorreu um erro ao eliminar artigo', 'error');
                        // this.consoleLog(error);
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedIndex = -1;
                        this.selectedArticle = this.getNewArticle;
                    });
                }catch (e) {
                    this.loading_modal = false;
                    this.showSnackBar('Ocorreu um erro ao eliminar permanentemente o artigo', 'error');
                    // this.consoleLog(e);
                }
            },

            showItem(item){
                this.articleShow = true;
                this.selectedIndex = this.articles.indexOf(item);
                this.selectedArticle = item;
                this.consoleLog(item);
                this.showArticleModal = true;
                eventBus.$emit('onArticleModalOpen', true);
            },

            editItem (item) {
                this.selectedIndex = this.articles.indexOf(item);
                this.selectedArticle = item;
                this.showArticleModal = true
                eventBus.$emit('onArticleModalOpen', true);
            },

            deleteItem (item) {
                this.confirmationModalOp = 1;
                this.selectedIndex = this.articles.indexOf(item);
                this.selectedArticle = item;
                this.openConfirmationDialog = true;
            },

            restoreTrashedItem (item){
                this.confirmationModalOp = 2;
                this.selectedIndex = this.articles.indexOf(item);
                this.selectedArticle = item;
                this.openConfirmationDialog = true;
            },

            deleteTrashedItem (item){
                this.confirmationModalOp = 3;
                this.selectedIndex = this.articles.indexOf(item);
                this.selectedArticle = item;
                this.openConfirmationDialog = true;
            },

            close () {
                this.showArticleModal = false;
                this.openConfirmationDialog = false;
                this.articleShow = false;
                this.loading = false;
                if(this.$v) this.$v.$reset();
                let vm = this;
                setTimeout(() => {
                    vm.selectedArticle = null;
                    vm.selectedIndex = -1
                }, 300)
            },

            openModal(){
                this.selectedArticle = this.getNewArticle;
                this.showArticleModal = true;
                eventBus.$emit('onArticleModalOpen', true);
            },

            confirmationDialogYes(){
                if(this.confirmationModalOp === 1){
                    this.delete();
                }else if(this.confirmationModalOp === 2){
                    this.restoreTrashed();
                }else if(this.confirmationModalOp === 3){
                    this.deleteTrashed();
                }


            }
        },


    }
</script>

<style scoped>

</style>